import { useQuery } from "@apollo/client";
import { useState } from "react";
import { FIRMA_BY_ID_TICKETDATA } from "../../api/firma/queries";
import { getKommuneByKommuneKode } from "../../util/kommune";
import AutoCompleteFirma from "../autocomplete/AutoCompleteFirma";
import {
  AutoCompleteItem,
  FirmaAutoCompleteResponse,
} from "../autocomplete/interface";
import FirmaIcon from "../icons/FirmaIcon";
import ValidationErrorMessage from "./ValidationErrorMessage";
import FormControlButton from "../button/FormControlButton";
import IsRequired from "./common/IsRequired";

export default function FirmaFormControl<U>(props: FormikFirmaControlProps<U>) {
  const [selectedItem, setSelectedItem] = useState<
    | AutoCompleteItem<
        | {
            firmaer: {
              edges: {
                node: FirmaAutoCompleteResponse;
              }[];
            };
          }
        | undefined
      >
    | undefined
  >(undefined);
  const { config, formik, value, disabled } = props;
  const { setFieldValue, setFieldTouched, touched, errors } = formik;
  const { id, label, isRequired } = config;
  const removeFirma = () => {
    setFocusOnChange(true);
    setFieldTouched(id, true);
    setFieldValue(id, undefined);
  };
  const { data, loading } = useQuery<{
    firma: {
      id: string;
      navn1: string;
      navn2: string;
      firmaNr: number;
      kommuneNr: string;
    };
  }>(FIRMA_BY_ID_TICKETDATA, {
    variables: { id: value },
    skip: selectedItem !== undefined || !value,
  });
  const firma = data ? data.firma : undefined;

  const kommune = getKommuneByKommuneKode(firma?.kommuneNr ?? "");

  const qSelectedItem: AutoCompleteItem | undefined = firma
    ? {
        id: firma.id,
        header: `${firma.navn1}`,
        subheader: `Firmanr: ${firma.firmaNr} |  ${
          kommune ? kommune.navn : "Ukendt"
        } kommune`,
        icon: <FirmaIcon height={26} />,
      }
    : loading
      ? {
          id: value ?? "",
          header: "Henter ...",
          subheader: "",
          icon: <FirmaIcon height={26} />,
        }
      : undefined;

  const [focusOnChange, setFocusOnChange] = useState(false);
  return (
    <>
      <label className="form-label" htmlFor={id}>
        {label}
        {isRequired && <IsRequired />}
      </label>

      {value && qSelectedItem && (
        <FormControlButton
          disabled={disabled}
          selectedItem={qSelectedItem}
          remove={() => {
            removeFirma();
          }}
          shouldFocusOnMount={focusOnChange}
        />
      )}
      {value && selectedItem && !qSelectedItem && (
        <FormControlButton
          disabled={disabled}
          selectedItem={selectedItem}
          remove={() => {
            removeFirma();
          }}
          shouldFocusOnMount={focusOnChange}
        />
      )}
      {!value && (
        <AutoCompleteFirma
          placeholder="Søg og vælg firma ..."
          className={`w-100`}
          isInvalidClass={
            touched[id] && (errors as any)[id] ? "is-invalid" : ""
          }
          includeFirstItem={false}
          onSelectedItemChange={({ selectedItem }) => {
            if (selectedItem) {
              setFocusOnChange(true);
              setFieldValue(id, selectedItem.id);
              setSelectedItem(selectedItem);
            }
          }}
          onInputBlur={() => {
            setFieldTouched(id, true);
          }}
          focusInputOnMount={focusOnChange}
        />
      )}
      <ValidationErrorMessage
        touched={touched[id]}
        errorMessage={(errors as any)[id]}
      />
    </>
  );
}
